import styled from 'styled-components'

import { mediaIpad, mediaIpadmini, mediaMobile } from './desktop'

export const Headercomponents = styled.div`
    display: flex; 
    width: 80%;
  ${mediaMobile.Mobile`
    display: none;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const HeaderIconcomponents = styled.div`
    display: flex; 
    align-items: center;
  ${mediaMobile.Mobile`
    display: none;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const Responsivecomponents = styled.div`
    display: none;
  ${mediaMobile.Mobile`
    display: flex;
    justify-content: center;
    width: 100%;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const HeaderReponcomponents = styled.div`
    display: none;
  ${mediaMobile.Mobile`
    display: flex;
    justify-content: center;
    width: 95%;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const HeaderIconReponcomponents = styled.div`
    display: none;
  ${mediaMobile.Mobile`
    display: flex;
    width: 5%;
    justify-content: flex-end;
    align-items: center;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`



// WEBPACK FOOTER //
// ./src/components/styled-components/headerStyled.js